import { render, staticRenderFns } from "./forgetPasw.vue?vue&type=template&id=b1bfb070&scoped=true"
import script from "./forgetPasw.vue?vue&type=script&lang=js"
export * from "./forgetPasw.vue?vue&type=script&lang=js"
import style0 from "./forgetPasw.vue?vue&type=style&index=0&id=b1bfb070&prod&lang=less&scoped=true"
import style1 from "./forgetPasw.vue?vue&type=style&index=1&id=b1bfb070&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bfb070",
  null
  
)

export default component.exports